import { render, staticRenderFns } from "./InputNumberCurrency.vue?vue&type=template&id=3b5c677e"
import script from "./InputNumberCurrency.vue?vue&type=script&lang=js"
export * from "./InputNumberCurrency.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports